import type { BookingStatus } from '../../types'
import { cn } from '../../utils/cn'

const STATUS_STYLES: Record<BookingStatus, string> = {
  confirmed: 'bg-white/20 border-dash-success-line text-dash-success-text',
  pending: 'bg-white/20 border-dash-warning-line text-dash-warning-text',
  cancelled: 'bg-white/20 border-dash-danger-line text-dash-danger-text',
  'in-progress': 'bg-white/[0.31] border-dash-link text-dash-link',
}

const STATUS_LABELS: Record<BookingStatus, string> = {
  confirmed: 'Confirmed',
  pending: 'Pending',
  cancelled: 'Cancelled',
  'in-progress': 'In Progress',
}

const SIZE_STYLES = {
  /** Used inside the Upcoming Trips table. */
  md: 'h-[32px] text-[16px]',
  /** Used inside the Recent Bookings list. */
  sm: 'h-[23px] text-[12px]',
} as const

/** Pill widths are fixed per label in the design rather than derived from padding. */
const PILL_WIDTHS: Record<keyof typeof SIZE_STYLES, Record<BookingStatus, string>> = {
  md: {
    confirmed: 'w-[107px]',
    pending: 'w-[105px]',
    cancelled: 'w-[105px]',
    'in-progress': 'w-[105px]',
  },
  sm: {
    confirmed: 'w-[95px]',
    pending: 'w-[74px]',
    cancelled: 'w-[82px]',
    'in-progress': 'w-[95px]',
  },
}

type StatusPillProps = {
  status: BookingStatus
  size?: keyof typeof SIZE_STYLES
}

export const StatusPill = ({ status, size = 'md' }: StatusPillProps) => (
  <span
    className={cn(
      'inline-flex shrink-0 items-center justify-center whitespace-nowrap rounded-[35px] border-[0.5px] border-solid font-host font-medium',
      STATUS_STYLES[status],
      SIZE_STYLES[size],
      PILL_WIDTHS[size][status],
    )}
  >
    {STATUS_LABELS[status]}
  </span>
)
